document.addEventListener('DOMContentLoaded', function () {
  const modal = document.getElementById('editionsInquiryModal');
  if (!modal) return;

  const openButtons = document.querySelectorAll('[data-open-editions-inquiry]');
  const closeButtons = modal.querySelectorAll('[data-close-editions-inquiry]');
  const dialog = modal.querySelector('.editions-inquiry-modal__dialog');

  const subjectField = modal.querySelector('#EditionsInquirySubject');
  const workField = modal.querySelector('#EditionsInquiryWork');
  const inquiryTypeField = modal.querySelector('#EditionsInquiryType');
  const collectorTypeField = modal.querySelector('#EditionsCollectorType');

  function openModal(button) {
    const subject = button.getAttribute('data-inquiry-subject') || 'Edition Inquiry';
    const work = button.getAttribute('data-inquiry-work') || '';

    if (subjectField) subjectField.value = subject;
    if (workField) workField.value = work;
    if (inquiryTypeField) inquiryTypeField.value = 'Edition Acquisition';


    modal.classList.add('is-active');
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('editions-inquiry-modal-open');
  }

  function closeModal() {
    modal.classList.remove('is-active');
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('editions-inquiry-modal-open');
  }

  openButtons.forEach(function (button) {
    button.addEventListener('click', function (event) {
      event.preventDefault();
      openModal(button);
    });
  });

  closeButtons.forEach(function (button) {
    button.addEventListener('click', function (event) {
      event.preventDefault();
      closeModal();
    });
  });

  modal.addEventListener('click', function (event) {
    if (!dialog.contains(event.target)) {
      closeModal();
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && modal.classList.contains('is-active')) {
      closeModal();
    }
  });
});